import React from 'react';
import { Text } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';

type Props = {
  item: LineItem;
};

export const LineItemBackInStock: React.FC<Props> = ({ item }) => {
  if (!item.attributes.backInStock || item.type !== 'saved_items') return null;

  return (
    <Text treatment="body2" color="money-good">
      Back in Stock
    </Text>
  );
};
